import { gql } from '@apollo/client';

export const MY_POSITIONS_HARVESTER_STATUSES = ({
  ids
}: {
  ids: string[];
}) => gql`
  query statuses {
    positions(
      where: { id_in: [${ids.map((id) => `"${id}"`).join(',')}] }
    ) {
      id
      harvestFraction
      recipients {
        distributionShare
        id
      }
      owner {
        id
      }
    }
  }
`;

export const MY_POSITIONS_HARVESTER_OWNER_TOKEN_IDS = ({
  owner
}: {
  owner: string;
}) => gql`
  query ownerTokenIds {
    positions(first: 1, where: { owner: "${owner}" }) {
      owner {
        ownerOfPositions {
          id
        }
      }
    }
  }
`;

export const MY_POSITIONS_STAKER_OWNER_TOKEN_IDS = ({
  owner
}: {
  owner: string;
}) => gql`
  query stakerOwnerTokenIds {
    deposits(where: { owner: "${owner}" }) {
      id
    }
  }
`;

export const POOLS_MY_POSITIONS = ({ origin }: { origin: string }) => gql`
  query poolsMyPositions {
    pools(where: { mints_: { origin: "${origin}" } }) {
      id
      mints(where: { origin: "${origin}" }) {
        origin
        amount
      }
      burns(where: { origin: "${origin}" }) {
        origin
        amount
      }
    }
  }
`;

export const STAKER_DEPOSIT_OWNER = ({
  positionId
}: {
  positionId: string;
}) => gql`
  query stakerDepositOwner {
    deposit(id: "${positionId}") {
      owner
    }
  }
`;

export const STAKER_DEPOSITS_NOT_HARVESTED = ({
  owner
}: {
  owner: string;
}) => gql`
  query stakerDepositsNotHarvested {
    deposits(where: { owner: "${owner}", isAutoHarvested: false }) {
      id
    }
  }
`;
